import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { Home as HomeDe } from './pages/Home-de';
import { ThankYou } from './pages/ThankYou';
import { SignIn } from './pages/SignIn';
import { GoogleAnalytics } from './components/GoogleAnalytics';

import './styles/custom.sass';

function App() {
  return (
    <BrowserRouter>
      <GoogleAnalytics />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/de' element={<HomeDe />} />
        <Route path='/ua' element={<Navigate to='/' replace />} />
        <Route path='/ru' element={<Navigate to='/' replace />} />
        <Route path='/thank-you' element={<ThankYou />} />
        <Route path='/sign-in' element={<SignIn />} />
      </Routes>
    </BrowserRouter>
  );
}

export { App };
